/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { Theme } from "../types"

export default function ByUsLogo() {
    return (
        <div css={styles.root}>
            <a href="https://balker.hu" css={styles.logo}>
                <img src="/balker_logo.png" alt="balker logo" />
            </a>
        </div>
    )
}

const styles = {
    root: (theme: Theme) => css`
        color: ${theme.colors.grey[600]};
        display: flex;
        justify-content: center;
        padding: ${theme.spaces.smallScale.l} 0;
    `,
    by: css`
        margin-right: 0.5rem;
    `,
    logo: css`
        & img {
            border-radius: 12px;
            width: 200px;
        }
    `,
}
